<template>
  <div class="action-bar">
    <div class="action-buttons">
      <el-button-group class="mobile-group">
        <el-button
          type="primary"
          plain
          icon="el-icon-thumb"
          @click="$emit('like', video)"
        >
          <span class="btn-text">喜欢</span> {{ video.thumbUp }}
        </el-button>
        <el-button
          type="info"
          plain
          icon="el-icon-bottom"
          @click="$emit('dislike', video)"
        />
      </el-button-group>

      <el-button
        type="warning"
        icon="el-icon-star-off"
        class="ml-10"
        @click="$emit('collect', video)"
      >
        <span class="btn-text">收藏</span> {{ video.favorite }}
      </el-button>

      <el-button
        type="success"
        icon="el-icon-share"
        plain
        @click="$emit('share')"
      >
        <span class="btn-text">分享</span>
      </el-button>

      <el-button
        icon="el-icon-download"
        plain
        @click="$emit('download', video.videoId)"
      >
        <span class="btn-text">下载</span>
      </el-button>

      <el-dropdown trigger="click" class="ml-10">
        <el-button icon="el-icon-more" circle size="small" />
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :divided="showEdit" @click.native="$emit('report')">
            <i class="el-icon-warning-outline" /> 报错
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoOpsCard',
  props: {
    video: {
      type: Object,
      required: true
    },
    showEdit: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.action-bar {
  padding-top: 15px;
  border-top: 1px solid #333;
}

.action-buttons {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  overflow-x: auto;
  scrollbar-width: none;
}
.action-buttons::-webkit-scrollbar { display: none; }

.ml-10 { margin-left: 10px; }

@media screen and (max-width: 768px) {
  .action-bar {
    padding: 10px 0;
    border-top: 1px solid #eee;
  }
  .action-buttons {
    justify-content: space-around;
    width: 100%;
  }
  .el-button.ml-10 {
    margin-left: 5px !important;
  }
  .el-button {
    padding: 8px 10px !important;
    font-size: 12px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: none !important;
    background: transparent !important;
    color: #606266 !important;
  }
  .action-buttons i {
    font-size: 20px !important;
    margin-bottom: 4px;
    margin-right: 0 !important;
  }
  .btn-text {
    font-size: 11px;
    color: #909399;
  }
  .el-button [class*="el-icon-"] + span {
    margin-left: 0 !important;
  }
}
</style>
